var AdaptiveImage = require( "../../../../../../react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "35ba0eaec5a4f5ed12ca16fabeae451d.png",
    width: 96,
    height: 96
});